<template>
  <el-container class="full">
    <!-- 侧边 -->
    <el-aside width="200px">
      <side-bar>
        <div
          slot="trademark"
          class="title-box">
          <span>云伙伴管理后台</span>
        </div>
        <div slot="router">
          <component
            v-for="item in menuList"
            :key="item.name"
            :data="item"
            :is="item.children?'sub-menu':'menu-item'"/>
        </div>
      </side-bar>
    </el-aside>
    <el-container class="full-height bg-gray">
      <!-- 头部 -->
      <el-header
        class="no-padding header"
        style="height:73px">
        <top-bar/>
      </el-header>
      <!-- 主体 -->
      <div class="main">
        <router-view/>
      </div>
    </el-container>
  </el-container>
</template>
<script>
/* eslint-disable space-infix-ops */

import TopBar from '../components/TopBar';
import SideBar from '../components/side-bar';
import MenuItem from '../components/side-bar/menu-item';
import SubMenu from '../components/side-bar/sub-menu';

export default {
  name: 'Index',
  data() {
    return {
      menuList: [
        {
          name: '轮播图管理',
          route: '/slideimg-manage',
        },
        {
          name: '案例管理',
          route: '/casemanage',
        },
        // {
        //   name: '产品解析',
        //   route: '/productanalysis',
        // },
        {
          name: '文章管理',
          route: '/articlemanage',
        },
        {
          name: '合作伙伴管理',
          route: '/clientmanage',
        },
        {
          name: '合作咨询',
          route: '/cooperateconsult',
        },
        {
          name: '首页服务管理',
          route: '/service-mange',
        },
        {
          name: '友情链接管理',
          route: '/friendly-link',
        },
        {
          name: 'tdk设置',
          route: '/tdk-mange',
        }
      ],
    };
  },
  components: {
    TopBar,
    SideBar,
    MenuItem,
    SubMenu,
  },
};
</script>

<style lang="less" scoped>
.title-box{
  font-size: 18px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.full-height {
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}
.main {
  margin: 20px 50px 40px 50px;
}
</style>
